import { z } from "zod";

import { breakDown } from "./daily-report.schema";

import { basicValidator } from "@/lib/validators";

export const AddTimeSheetSchema = z.object({
  startTime: z.union([z.number(), z.date()]),
  endTime: z.union([z.number(), z.date()]),
  break: z.coerce.number().min(0),
  reportId: basicValidator(true, "Report is Required"),
  note: basicValidator(false),
  isVerified: z.boolean(),
  // workhour is for frontend only
  workHour: z.union([z.number(), z.date()]).optional(),

  workBreakDown: z.array(breakDown),
});

export const UpdateTimeSheetSchema = AddTimeSheetSchema.partial();

export type T_AddTimeSheetSchema = z.infer<typeof AddTimeSheetSchema>;
export type T_UpdateTimeSheetSchema = z.infer<typeof UpdateTimeSheetSchema>;
